import { Account } from '@features/accounts';
import { Theme } from '@radix-ui/themes';
import { DataLoaderWrapper, ProductionsSelectionPagePath } from '@router';
import { useNavigate } from 'react-router-dom';
import { useSelectedUserAccounts, useSelectAccount } from '../hooks';
import { AccountSelectionUI } from './AccountSelectionUI';
import { Layout } from '@common/layouts';
import { getAccountsWhitelist } from '@services';

export const AccountSelectionPage = () => {
    const navigate = useNavigate();
    const { data, isLoading, isError } = useSelectedUserAccounts();
    const { selectAccount } = useSelectAccount();

    const whitelist = getAccountsWhitelist();

    const handleAccountSelect = (account: Account) => {
        selectAccount(account);
        navigate(ProductionsSelectionPagePath);
    };

    const activeAccounts =
        data
            .filter((account) => whitelist.includes(String(account.id)))
            .filter((account) => account.status !== 'unlinked')
            .sort((a, b) => Number(a.id) - Number(b.id)) || [];

    return (
        <Layout.Content centered>
            <Theme accentColor={'gray'}>
                <DataLoaderWrapper isError={isError} isLoading={isLoading}>
                    <AccountSelectionUI
                        accounts={activeAccounts}
                        onSelectAccount={handleAccountSelect}
                    />
                </DataLoaderWrapper>
            </Theme>
        </Layout.Content>
    );
};
